export default __webpack_public_path__ + "static/media/revolab-logo_with-text.7a86be48.svg";